export default {
  A4: 1.4142,
  Badge: 1,
  Card: 1.56,
  NFT: 1,
};
